import { Color } from 'palette/Colors';
import { TypographyProps } from 'palette/Typography';
import {
    ProductPricesCollection,
    ProductPrices,
    ProductPriceTypographyStructure,
    ProductPrice,
    VolumeDiscount,
    VolumeDiscountPrices,
} from '../types';

export function getPriceTypographyProps(
    priceElement: ProductPrice,
    typographyStructure: Partial<ProductPriceTypographyStructure>,
): TypographyProps {
    const {
        strike_through: isStrikeTrough,
        text_size: size,
    } = priceElement;

    const productPriceBaseProps = {
        color: 'inherit' as Color,
        isStrikeTrough,
        tagName: 'span',
    };

    const productPriceTypographyProps = typographyStructure[size];

    return {
        ...productPriceBaseProps,
        ...productPriceTypographyProps && productPriceTypographyProps,
    } as TypographyProps;
}

export function getEanId(product: any): number {
    const { ean_id } = product;

    return ean_id;
}

export function getProductPricesStructure(
    eanId: number, isActivated: boolean, productPricesStructure: Record<number, ProductPrices>,
): ProductPricesCollection[] {
    const { mdv_prices = [], prices = [] } = productPricesStructure?.[eanId] ?? {};

    return (isActivated && mdv_prices && mdv_prices.length > 0) ? mdv_prices : prices;
}

export function getVolumeDiscountPricesStructure(
    eanId: number,
    isActivated: boolean,
    volumeDiscount: VolumeDiscount,
    volumeDiscountWithMDV: VolumeDiscount,
): ProductPricesCollection[] {
    const currentVolumeDiscountOption: VolumeDiscountPrices = volumeDiscount?.selected?.[eanId] || null;
    const currentVolumeDiscountOptionWithMDV: VolumeDiscountPrices = volumeDiscountWithMDV?.selected?.[eanId] || null;

    const hasVolumeDiscount = Boolean(volumeDiscount);
    const hasVolumeDiscountWithMDV = Boolean(volumeDiscountWithMDV);

    if (hasVolumeDiscountWithMDV && isActivated) {
        const { mdv_prices = [] } = currentVolumeDiscountOptionWithMDV?.pricing_strategies || {};
        return mdv_prices;
    }

    if (hasVolumeDiscount && !isActivated) {
        const { prices = [] } = currentVolumeDiscountOption?.pricing_strategies || {};
        return prices;
    }

    return [];
}
